import { Flex, FlexProps } from 'components';
import { PropsWithChildren } from 'react';

interface CenteredLayoutProps extends FlexProps {}

const CenteredLayout = ({ maxWidth = 550, px = 4, py = 4, children, ...props }: PropsWithChildren<CenteredLayoutProps>) => {
  return (
    <Flex justifyContent="center" alignItems="center" minWidth="100vw" minHeight="100vh" bg="primary_10">
      <Flex
        flexGrow={1}
        bg="white"
        border={1}
        borderStyle="solid"
        borderColor="gray_300"
        borderRadius={4}
        flexDirection="column"
        alignItems="center"
        maxWidth={maxWidth}
        px={px}
        py={py}
        style={{ gap: 20 }}
        {...props}
      >
        <img src="/images/melver-nas-escolas/logo.png" width="100%" style={{ maxWidth: 270 }} alt="MELVER nas Escolas" />

        {children}
      </Flex>
    </Flex>
  );
};

export default CenteredLayout;
